import { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import JobZImage from "../../../common/jobz-img";
import { loadScript, getJobDetailUrl } from "../../../../globals/constants";
import { jobService } from "../../../../services/job-service";
import { publicUser } from "../../../../globals/route-names";

function CanSavedJobsPage() {
    const [jobs, setJobs] = useState([]);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        jobService.mySavedJobs()
            .then((data) => setJobs(data.jobs || []))
            .catch((error) => setMessage(error.message))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        loadScript("js/custom.js");
        load();
    }, []);

    const remove = async (jobId) => {
        try {
            await jobService.unsave(jobId);
            setMessage("Saved job removed.");
            load();
        } catch (error) {
            setMessage(error.message);
        }
    };

    return (
        <>
            <div className="twm-right-section-panel candidate-save-job site-bg-gray">
                {message && <div className="alert alert-info">{message}</div>}
                {loading ? (
                    <div className="p-a30 text-center">Loading saved jobs...</div>
                ) : (
                    <div className="twm-D_table table-responsive">
                        <table className="table table-bordered twm-candidate-save-job-list-wrap">
                            <thead>
                                <tr>
                                    <th>Job Title</th>
                                    <th>Company</th>
                                    <th>Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobs.length === 0 ? (
                                    <tr>
                                        <td colSpan={4} className="text-center">
                                            <div className="zz-empty-state">
                                                <i className="fa fa-bookmark" />
                                                <h4>No saved jobs yet.</h4>
                                                <NavLink className="site-button" to={publicUser.jobs.LIST}>Browse Jobs</NavLink>
                                            </div>
                                        </td>
                                    </tr>
                                ) : jobs.map((job, index) => (
                                    <tr key={job.id}>
                                        <td>
                                            <div className="twm-candidate-save-job-list">
                                                <div className="twm-media">
                                                    <div className="twm-media-pic">
                                                        <JobZImage src={`images/jobs-company/pic${(index % 5) + 1}.jpg`} alt="#" />
                                                    </div>
                                                </div>
                                                <div className="twm-mid-content">
                                                    <Link to={getJobDetailUrl(job)} className="twm-job-title">
                                                        <h4>{job.title}</h4>
                                                    </Link>
                                                </div>
                                            </div>
                                        </td>
                                        <td><span>{job.company_name || "Company"}</span></td>
                                        <td><div>{formatDate(job.created_at)}</div></td>
                                        <td>
                                            <div className="twm-table-controls">
                                                <ul className="twm-DT-controls-icon list-unstyled">
                                                    <li>
                                                        <Link to={getJobDetailUrl(job)} className="custom-toltip">
                                                            <span className="fa fa-eye" />
                                                            <span className="custom-toltip-block">View</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <button title="Delete" type="button" onClick={() => remove(job.id)}>
                                                            <span className="far fa-trash-alt" />
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </>
    )
}

function formatDate(value) {
    if (!value) return "";
    return new Date(value).toLocaleDateString();
}

export default CanSavedJobsPage;
